<template>
    <div class="team">
        <Navbar />
        <v-content>
            <v-container grid-list-md>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md6 lg3 v-if="team.name">
                        <h3>Name</h3>
                        <p>{{team.name}}</p>
                    </v-flex>
                    <v-flex xs12 md6 lg3 v-if="team.type">
                        <h3>Type</h3>
                        <p>{{team.type}}</p>
                    </v-flex>
                    <v-flex xs12 md6 lg3 v-if="team.makeup_center">
                        <h3>Makeup Center</h3>
                        <p>{{team.makeup_center}}</p>
                    </v-flex>
                    <v-flex xs12 md6 lg3 v-if="team.medivac != null">
                        <h3>Medivac</h3>
                        <v-icon v-if="team.medivac">done</v-icon>
                        <v-icon v-if="!team.medivac">clear</v-icon>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-snackbar v-model="notExists" :right="true">
            Team can't be loaded.
            <v-btn color="pink" flat @click="notExists = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        data() {
            return {
                team: {
                    id: '',
                    name: '',
                    type: '',
                    makeup_center: 0,
                    medivac: false,
                    exercise_id: this.$route.params.e_id
                },
                notExists: false
            }
        },
        components: {
            Navbar
        },
        methods: {
            loadTeam() {
                var exerciseID = this.$route.params.e_id
                var teamID = this.$route.params.id
                axios.get('/exercises/' + exerciseID + '/teams/' + teamID).then(response => {
                    this.team = response.data
                }).catch(error => {
                    this.notExists = true
                })
            }
        },
        mounted() {
            this.loadTeam();
        }
    }
</script>